@if (previewContext || (isV2BundleChecklist && reportSummary)) {
	<div class="checklist-detail">
		@if (step === "preview") {
			@if (isV2BundleChecklist && reportSummary) {
				<app-report-summary
					[checklistMode]="true"
					[initialStepIndex]="previewStepIndex"
					[embeddedCandidateId]="candidateId"
					[embeddedReportSummary]="reportSummary"
					(checklistBack)="onPreviewBack()"
					(checklistNext)="onPreviewNext()"
				></app-report-summary>
			} @else if (previewContext) {
				<app-ts1-rating-preview-summary
				[candidateNames]="previewContext.candidateNames"
				[candidateCrewRoles]="previewContext.candidateCrewRoles"
				[candidateIds]="previewContext.candidateIds"
				[maneuverOutcomes]="previewContext.maneuverOutcomes"
				[temCompetencyOutcomes]="previewContext.temCompetencyOutcomes"
				[signOffForm]="previewContext.signOffForm"
				[embedded]="true"
				[initialCandidateIndex]="candidateIndex"
				[hideCandidateNav]="true"
				[checklistFooter]="true"
				[competencyBlocksForIndex]="blocksForIndex"
				[maneuverRowsForIndex]="rowsForIndex"
				[summaryCommentsForIndex]="commentsForIndex"
				[competencyObCommentsForIndex]="obCommentsForIndex"
				[traineeAssessmentIdForIndex]="traineeAssessmentIdForIndex"
				[candidateDetailsForIndex]="detailsForIndex"
				[reminderNotesEnabled]="reminderNotesEnabledForPreview()"
				[useStructuredReminderNotes]="structuredReminderNotesForPreview()"
				(close)="onPreviewBack()"
				(next)="onPreviewNext()"
			></app-ts1-rating-preview-summary>
			}
		} @else if (step === "maneuvers" && hasManeuverBreakdown && previewContext) {
			@if (isV4Layout) {
				<app-ts1-v4-maneuver-breakdown
					[reportSummary]="reportSummary!"
					[previewContext]="previewContext"
					[maneuverBreakdownView]="reportSummary?.ts1V3PreviewSummary?.maneuverBreakdownView ?? []"
				></app-ts1-v4-maneuver-breakdown>
			} @else {
				<app-ts1-v3-maneuver-breakdown
					[reportSummary]="reportSummary!"
					[previewContext]="previewContext"
					[maneuverBreakdownView]="reportSummary?.ts1V3PreviewSummary?.maneuverBreakdownView ?? []"
				></app-ts1-v3-maneuver-breakdown>
			}

			<div class="checklist-detail__page-actions">
				<button type="button" class="aa-btn" data-variant="tertiary" (click)="onManeuversPrevious()">Previous</button>
				<button type="button" class="aa-btn" data-variant="tertiary" (click)="onManeuversNext()">Next</button>
			</div>
		} @else if (step === "signoff") {
			<app-checklist-candidate-signoff
				[instructor]="instructorSignoff"
				[candidateName]="candidateName"
				[candidateSignaturePreview]="candidateSignaturePreview"
				[candidateSignedAt]="candidateSignedAt"
				[feedbackTask]="feedbackTask"
				[feedbackPending]="feedbackPending"
				[completeDisabled]="isCompleteDisabled"
				[signing]="signing"
				(back)="onSignoffBack()"
				(sign)="openCandidateSignOff()"
				(complete)="completeSignOff()"
				(feedbackCompleted)="onFeedbackCompleted()"
				(feedbackFormValidChange)="feedbackFormValid = $event"
			></app-checklist-candidate-signoff>
		}
	</div>
} @else if (loadError) {
	<div class="checklist-detail px-6 py-8">
		<p>{{ loadError }}</p>
		<button type="button" class="aa-btn mt-4" data-variant="tertiary" (click)="goBack()">Back</button>
	</div>
} @else {
	<div class="checklist-detail flex min-h-[40vh] items-center justify-center px-6 py-12 text-sm text-gray-600">
		Loading checklist…
	</div>
}
